import * as React from 'react';
import { HeroImage } from './HeroImage';
import { Category, HeroPanelContent, HeroPanelWrapper, Title } from './index.style';

interface HeroPanelProps {
  children: React.ReactNode;
}

export const HeroPanel = (props: HeroPanelProps) => (
  <HeroPanelWrapper>
    {props.children}
    <HeroImage />
    <HeroPanelContent>
      <Category>Inspire</Category>
      <Title>
        Inspiring your
        <br />
        home journey
      </Title>
    </HeroPanelContent>
  </HeroPanelWrapper>
);
